module.exports = __webpack_public_path__ + "static/media/0km.c8320dfd.jpg";